import { useEffect, useState } from "react";
import api from "../api";
import { PlayCircle, X } from "lucide-react";

function getEmbedUrl(tip) {
  if (tip?.vimeo_url) {
    if (tip.vimeo_url.includes("player.vimeo.com")) return tip.vimeo_url;
    const m = tip.vimeo_url.match(/vimeo\.com\/(\d+)/);
    if (m) return `https://player.vimeo.com/video/${m[1]}?title=0&byline=0&portrait=0`;
    return tip.vimeo_url;
  }
  if (tip?.youtube_url) {
    const m = tip.youtube_url.match(/(?:youtu\.be\/|v=)([\w-]{11})/);
    if (m) return `https://www.youtube.com/embed/${m[1]}`;
    return tip.youtube_url;
  }
  return null;
}

export default function TipOfWeekBadge() {
  const [tip, setTip] = useState(null);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/tips/current").then(({ data }) => setTip(data)).catch(() => {});
  }, []);

  if (!tip || dismissed) return null;
  const embed = getEmbedUrl(tip);
  if (!embed) return null;

  return (
    <>
      {/* Floating badge */}
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-40 group"
        data-testid="tip-of-week-badge"
      >
        <div className="flex items-center gap-3 bg-[#2D4A3E] text-[#F9F6F0] pl-2 pr-5 py-2 rounded-full shadow-2xl hover:bg-[#1F352C] transition-all">
          <div className="relative w-10 h-10 rounded-full bg-[#D47C59] flex items-center justify-center flex-shrink-0">
            <PlayCircle className="w-6 h-6 text-white" strokeWidth={1.5} />
            <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-[#D47C59] animate-ping" />
            <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-[#D47C59]" />
          </div>
          <div className="text-left hidden sm:block">
            <p className="overline text-[#D47C59]">{tip.week_label || "This week"}</p>
            <p className="font-serif text-sm leading-tight">Linda's Tip</p>
          </div>
        </div>
      </button>

      {open && (
        <div
          className="fixed inset-0 bg-[#1A2F25]/70 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
          data-testid="tip-modal"
        >
          <div
            className="bg-[#F9F6F0] rounded-2xl max-w-3xl w-full overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-5 border-b border-[#E5E0D8]">
              <div>
                <p className="overline text-[#D47C59]">{tip.week_label || "This week"}</p>
                <p className="font-serif text-2xl">{tip.title}</p>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => { setDismissed(true); setOpen(false); }}
                  className="text-xs text-[#5C6B62] hover:underline"
                  data-testid="tip-hide-today"
                >
                  Hide for now
                </button>
                <button onClick={() => setOpen(false)} className="btn-ghost p-2" data-testid="tip-close">
                  <X className="w-4 h-4" />
                </button>
              </div>
            </div>

            <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
              <iframe
                src={embed}
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title={tip.title}
              />
            </div>

            {tip.description && (
              <div className="p-5">
                <p className="text-[#5C6B62] font-light leading-relaxed">{tip.description}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
